module.exports = __webpack_public_path__ + "static/informe-1d36312f094807c7cda980cd192e5b95.pdf";